// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganicResultsPage_wrapper__n6Ipn"};